import { Injectable } from '@angular/core';

type PrimeNgFilter = { matchMode: 'in' | 'contains' | null; value: string | string[] };
@Injectable({
  providedIn: 'root',
})
export class TableDataService {
  constructor() {}

  public filterSort(e: any, source: any) {
    let filtered: any[] = [];

    const hasFilters = Object.values(e.filters).some((x: any) => x.value !== null && x.value !== '');
    if (hasFilters) {
      filtered = this.filter(e.filters, source);
      filtered = this.sortByThenBy(filtered, e.multiSortMeta);

      return { result: filtered.slice(e.first, e.first + 100), paginationLength: filtered.length };
    } else {
      const sorted = this.sortByThenBy(source, e.multiSortMeta);

      return { result: sorted.slice(e.first, e.first + 100), paginationLength: source.length };
    }
  }

  private filter(filters: PrimeNgFilter[], source: any) {
    let filtered: any[] = [];
    let count = 0;
    for (const [key, value] of Object.entries(filters)) {
      if (value.value) {
        if (count === 0) {
          filtered = (source as any).filter((x: any) => {
            const filterInputValue = x[key];
            if (!filterInputValue) {
              return;
            }
            if (value.matchMode === 'in') {
              return value.value.length === 0 || value.value.includes(filterInputValue);
            }
            return filterInputValue.toLowerCase().includes((value.value as string).toLowerCase());
          });
        } else {
          filtered = filtered.filter((x: any) => {
            const filterInputValue = x[key];
            if (!filterInputValue) {
              return;
            }
            if (value.matchMode === 'in') {
              return value.value.length === 0 || value.value.includes(filterInputValue);
            }
            return filterInputValue.toLowerCase().includes((value.value as string).toLowerCase());
          });
        }
        count++;
      }
    }
    return filtered;
  }

  private sortByThenBy(items: any, sortByFields: any) {
    return items.sort((a: any, b: any) => this.compare(a, b, sortByFields, 0));
  }

  private compare(a: any, b: any, sortByFields: any, index: any): any {
    index = index || 0;
    var currentKey = sortByFields[index]?.field;
    if (!currentKey) return;
    if (sortByFields[index].order === 1) {
      return a[currentKey] < b[currentKey]
        ? 1
        : a[currentKey] > b[currentKey]
          ? -1
          : this.compare(a, b, sortByFields, index + 1);
    }
    return a[currentKey] > b[currentKey]
      ? 1
      : a[currentKey] < b[currentKey]
        ? -1
        : this.compare(a, b, sortByFields, index + 1);
  }
}
